import { createAction } from '@reduxjs/toolkit';
export const fetchCurrentUserProfileSagaAction = createAction('currentUserProfile/getCurrentUserProfile');
export const saveCurrentUserProfileSagaAction = createAction('currentUserProfile/saveCurrentUserProfile');
